import React from 'react';
import PropTypes from 'prop-types';

export const SvgMinus = ({ width, height, color, ...props }) => (
  <svg
    width={width || '10px'}
    height={height || '10px'}
    viewBox="0 0 10 10"
    version="1.1"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g stroke={color || '#06A888'} strokeWidth="2">
        <path d="M0,5 L10,5" />
      </g>
    </g>
  </svg>
);

SvgMinus.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};
